import { z } from "zod"

import { apiClient, assertOk } from "@/api/generated/client.ts"
import { dataPointValueSchema } from "@/types/dataPointSchemas.ts"
import type { DataPointIntervalRequest, DataPointValue, TagPath } from "@/types/dataPointTypes.ts"

export const getTagIntervals = async (
  path: TagPath,
  req: DataPointIntervalRequest,
): Promise<DataPointValue[]> => {
  if (path.folder == true || !path.historyProvider || !path.driver || !path.tag) return []

  const { data, error, response } = await apiClient.GET(
    "/api/Tags/intervals/{provider}/{driver}/{path}",
    {
      params: {
        path: {
          provider: path.historyProvider,
          driver: path.driver,
          path: path.tag,
        },
        query: {
          Start: req.start.toISOString(),
          End: req.end.toISOString(),
          Interval: req.interval,
          AggMode: req.aggMode,
          PageSize: req.pageSize,
          Page: req.page,
        },
      },
    },
  )
  assertOk(response, error)

  // The generated TagValue marks `value` optional, but the backend always
  // serializes it (null when absent) -- the same required-but-nullable gap
  // that dataPointTypes.ts works around for DataPointValueDTO. Parsing here
  // both satisfies DataPointValue and turns a genuine contract break into a
  // thrown error react-query surfaces, instead of a silent undefined.
  return z.array(dataPointValueSchema).parse(data)
}
